<div>
  <i
    (click)="returnToManageCommissions()"
    class="fa-solid fa-circle-arrow-left back-icon float-start cursor-pointer"
    title="Back to Manage Commissions Page">
  </i>
</div>
<div class="page-header-bar">
  <section class="account-certificates">
    <h2>Account Certificate</h2>
    <button class="btn-primary action-btn filter-btn"
      data-backdrop="static"
      data-keyboard="false"
      (click)="openCertificateModal()"
      >
      + {{ certificates.length > 0 ? 'Replace' : 'Add' }} Certificate
    </button>
  </section>
  <div>View and manage your Account Certificate</div>
</div>
<div>
  <div class="certificates">
    @for (certificate of certificates; track certificate; let i = $index) {
      <div>
        <mat-card>
          <mat-card-header>
            <div class="headline">
              <span class="bold">Digital Certificate</span>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="headline">
              <div>
                <span class="bold">Subject Name:</span> {{certificate.certificateContent.subjectName}}
              </div>
              <div>
                <span class="bold">Subject Email:</span> {{certificate.certificateContent.subjectEmail}}
              </div>
              <div>
                <span class="bold">Expiration Date:</span> {{certificate.certificateContent.expirationDate | date: "MM/dd/yyyy"}}
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer>
            <mat-card-actions align="end">
              <button (click)="deleteConfirmationDialog(certificate.certificateGuid)"
                class="btn-secondary">
                Delete
              </button>
            </mat-card-actions>
          </mat-card-footer>
        </mat-card>
      </div>
    }
  </div>
</div>
